<app-centre-small-opener *ngIf="!isConfidentialValue" (keyup)="handleKeyboardEvent(meetingObj,$event)">
    <h2 mat-dialog-title dialogTitle class="pd-t-5px">Confidential Password</h2>
    <mat-form-field contentContainer *ngIf="confidentialIsCheck">
        <mat-label class="body-font-size">
            <p class="m-0">Password</p>
        </mat-label>
        <input [formControl]="password" id="password" matInput [type]="passwordHide ? 'password' : 'text'"
            class="body-font-size">
        <button mat-icon-button matSuffix (click)="passwordHide = !passwordHide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="passwordHide">
            <mat-icon>{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
    </mat-form-field>
    <mat-error *ngIf="show == true && password.invalid && confidentialIsCheck" contentContainer class="clr-red">
        *Password required</mat-error>
    <mat-error *ngIf="showLen==true && password.hasError('minlength') && !password.hasError('required') && confidentialIsCheck" contentContainer
        class="clr-red">*Password must have at least 8 characters</mat-error>
    <mat-form-field contentContainer *ngIf="confidentialIsCheck">
        <mat-label class="body-font-size">
            <p class="m-0">Confirm password</p>
        </mat-label>
        <input id="confirmPassword" [formControl]="confirmPassword" matInput [type]="confirmPasswordHide ? 'password' : 'text'"
            class="body-font-size">
        <button mat-icon-button matSuffix (click)="confirmPasswordHide = !confirmPasswordHide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="confirmPasswordHide">
            <mat-icon>{{confirmPasswordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
    </mat-form-field>
    <mat-error *ngIf="show == true && confirmPassword.invalid && confidentialIsCheck" contentContainer
        class="clr-red">*Confirm Password required</mat-error>
    <mat-error *ngIf="isShow ==true && password!=confirmPassword && confidentialIsCheck" contentContainer
        class="clr-red">*Passwords must match</mat-error>
    <mat-error *ngIf="showLen == true && confirmPassword.hasError('minlength') && confidentialIsCheck" contentContainer
        class="clr-red">*Confirm Password must have at least 8 characters</mat-error>
    <mat-form-field contentContainer *ngIf="!confidentialIsCheck && !isConfidentialValue">
        <mat-label class="body-font-size">
            <p class="m-0">Enter your decrypt password</p>
        </mat-label>
        <input [formControl]="decryptPassword" id="decryptPassword" matInput [type]="confirmPasswordHide ? 'password' : 'text'"
            class="body-font-size">
        <button mat-icon-button matSuffix (click)="confirmPasswordHide = !confirmPasswordHide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="confirmPasswordHide">
            <mat-icon>{{confirmPasswordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
    </mat-form-field>
    <mat-error *ngIf="show == true && decryptPassword.invalid && !confidentialIsCheck" contentContainer
        class="clr-red">*Decrypt Password required</mat-error>
    <mat-error *ngIf="show == true && decryptPassword.hasError('minlength') && !confidentialIsCheck" contentContainer
        class="clr-red">*Decrypt Password must have at least 8 characters</mat-error>
        <mat-error *ngIf="isShow ==true && passworddecrypt!=decryptPassword && !confidentialIsCheck" contentContainer
        class="clr-red">*Passwords Doesn't match</mat-error>
        <!-- <h4 contentContainer class="indicator body-font-size">*Minimum password length should be 8 characters</h4> -->
    <button mat-raised-button actions class="button-container primary"
        *ngIf="!confidentialIsCheck && !isConfidentialValue" (click)="decryptValidation()">
        OK
    </button>
    <button type="button" color = "primary" mat-raised-button actions class="button-container mar-l-8" (click)="validation()"
      *ngIf="confidentialIsCheck">
        SAVE
    </button>
    <button mat-raised-button actions color = "primary" class="button-container mar-l-8" *ngIf="confidentialIsCheck"
        (click)="cancelConfidential()">
        CANCEL
    </button>
    <button mat-raised-button actions color = "primary" class="button-container mar-l-8"
        *ngIf="!confidentialIsCheck && !isConfidentialValue" (click)="cancelDecrypt()">
        CANCEL
    </button>
</app-centre-small-opener>

<app-centre-small-opener *ngIf="isConfidentialValue" (keyup)="handleKeyboardEvent(meetingObj,$event)">
    <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Confidential Password </h2>
    <!-- <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
    <mat-divider class="mat-divider"></mat-divider> -->
    <mat-form-field contentContainer class="matInput-full-width">
        <mat-label class="body-font-size">
            <p class="m-0">Enter your decrypt password</p>
        </mat-label>
        <input [formControl]="decryptPassword" id="decryptPassword" matInput [type]="confirmPasswordHide ? 'password' : 'text'"
            class="matInput-full-width">
        <button mat-icon-button matSuffix (click)="confirmPasswordHide = !confirmPasswordHide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="confirmPasswordHide">
            <mat-icon>{{confirmPasswordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
    </mat-form-field>
    <mat-error *ngIf="show == true && decryptPassword.invalid" contentContainer class="clr-red">*Decrypt Password
        required</mat-error>
    <mat-error *ngIf="show == true && decryptPassword.hasError('minlength')" contentContainer class="clr-red">
        *Decrypt Password must have at least 8 characters</mat-error>
        <mat-error *ngIf="isShow ==true && !confidentialIsCheck" contentContainer
        class="clr-red">*Passwords Doesn't match</mat-error>
        <!-- <h4 contentContainer class="indicator body-font-size">*Minimum password length should be 8 characters</h4> -->
    <!-- <br> -->
    <!-- <button mat-raised-button actions class="button-container1 primary"
        (click)="meetingStartFlag ? startMeeting(meetingid) : redirectToMeeting(meetingid)">
        OK
    </button> -->
    <button type="button" color = "primary" mat-raised-button actions class="button-container mar-l-8"
        (click)="viewMeeting(meetingObj)">
        DONE
    </button>
    <button mat-raised-button color = "primary" actions class="button-container mar-l-8" (click)="close()">
        CANCEL
    </button>
</app-centre-small-opener>